<script setup lang="ts">
import GcsMark from "../branding/GcsMark.vue";

withDefaults(defineProps<{ label?: string; detail?: string }>(), {
  label: "正在啟動輿情分析系統…",
  detail: "",
});
</script>

<template>
  <div class="fixed inset-0 z-[100] grid place-items-center bg-surface px-6 text-ui" role="status" aria-live="polite" aria-busy="true">
    <div class="flex w-full max-w-sm flex-col items-center text-center">
      <div class="relative">
        <div class="absolute -inset-3 animate-ping rounded-[1.1rem] bg-cyan-500/10" />
        <GcsMark :size="72" />
      </div>
      <p class="mt-6 text-lg font-semibold tracking-tight">{{ label }}</p>
      <p v-if="detail" class="mt-2 text-sm text-ui-muted">{{ detail }}</p>
      <div class="mt-6 flex items-center gap-1.5" aria-hidden="true">
        <span class="size-1.5 animate-pulse rounded-full bg-cyan-300 [animation-delay:-.3s]" />
        <span class="size-1.5 animate-pulse rounded-full bg-cyan-400 [animation-delay:-.15s]" />
        <span class="size-1.5 animate-pulse rounded-full bg-cyan-500" />
      </div>
    </div>
  </div>
</template>
